import React from "react";

import Typography from "_components/atoms/typography";
import useStyles  from "_styles/pages/blogs/tagsComponent.js";

const TagsComponent = ( { categoryName, tags } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.tagsContainer }>
			<span>
				<Typography className = { classes.tagsHeading }
					title                = { `${ categoryName } > Tags` }
				/>
			</span>

			<div className = { classes.tagsInnerContainer }>
				{tags?.map ( tag => {
					return (
						<div key   = { tag.id }
							className = { classes.tagName }
						>
							<Typography title = { tag.name } />
						</div>
					);
				} )}
			</div>
		</div>
	);
};

export default TagsComponent;